import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from "@angular/router";
import { Observable,  } from "rxjs";
import { AuthenticationService } from "app/helpers/authentication.service";
import { EnumFuncoes } from "app/shared/enum.service";
import { Functions } from "app/helpers/functions";
import { NotificationsAtividadesDTO } from "../models/notifications-atividades.model";


@Injectable({
    providedIn: "root"
})
export class NotificationsAtividadesService extends CrudService<NotificationsAtividadesDTO> implements Resolve<any>{
    constructor(
        protected http: HttpClient,
        
    ) {
        super(http, `${environment.baseUrl}/Notificacoes`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {}


    getNotificacoesAtividades(idVendedor): Promise<any> {

        return new Promise((resolve, reject) => {
            this.http.get(`${environment.baseUrl}/Notificacoes/GetByVendedorId/${idVendedor}`).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    marcarNotificacaoLida(id): Promise<any> {

        return new Promise((resolve, reject) => {
            this.http.put(`${environment.baseUrl}/Notificacoes/MarcarNotificacaoLida/${id}`, {})
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    gerarNotificacao(atividadeId: number, acao: number): Promise<any> {

        let params = {
            atividadeId: atividadeId,
            acao: acao
        }

        return new Promise((resolve, reject) => {
            this.http.post(`${environment.baseUrl}/Notificacoes`, params)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
}